// extracted by mini-css-extract-plugin
export default {"inline-loader":"layout_inline-loader__EWXDI","spin":"layout_spin__01F-Q","main-content-container":"layout_main-content-container__QTLSl","eightshimmer":"layout_eightshimmer__tpF7w"};